<template>
  
  <div>

    <div id="create-customer-dialog" class="ui large modal create-customer-modal">

      <div class="ui header">
        Cadastro da empresa
      </div>

      <div class="content modal-content-scrolling">

        <form class="ui form" :class="{ loading }" @submit.prevent="onConfirm()">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Razão Social <span class="red text">*</span></label>
              <input type="text" v-model="customer.name">
            </div>
          </div>
          <div class="fields">
            <div class="six wide field">
              <label class="form-label">Estado <span class="red text">*</span></label>
              <select id="select-state" class="ui fluid dropdown form-dropdown" v-model="customer.state" @change="onChangeState()">
                <option value="*">Selecione...</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
            </div>
            <div class="ten wide field">
              <label class="form-label">Cidade <span class="red text">*</span></label>
              <select id="select-city" class="ui fluid search dropdown form-dropdown" v-model="customer.cityCode">
                <option v-for="city in cities" :value="city.id">{{ city.name }}</option>
              </select>
            </div>
          </div>
          <div class="fields">
            <div class="six wide field">
              <label class="form-label">CNPJ</label>
              <the-mask type="text" mask="##.###.###/####-##" :value="cnpj" readonly="readonly" />
            </div>
            <div class="two wide field">
              <label class="form-label">DDD <span class="red text">*</span></label>
              <the-mask type="tel" mask="###" v-model="customer.ddd" />
            </div>
            <div class="eight wide field">
              <label class="form-label">Telefone <span class="red text">*</span></label>
              <the-mask type="tel" :mask="['#####-####', '####-####']" v-model="customer.phone" />
            </div>
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">E-mail <span class="red text">*</span></label>
              <input type="email" v-model="customer.email">
            </div>
          </div>
        </form>

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>
        <button type="button" class="ui blue button" :class="{ loading: creating }" @click="onConfirm()">
          <i class="check icon"></i>
          Confirmar
        </button>
      </div>

    </div>

  </div>

</template>

<script>

  import { TheMask } from "vue-the-mask"
  import Message from "@/utils/message"
  import CustomerService from "@/services/customer-service"
  
  export default {

    data() {
      return {
        loading: false,
        creating: false,
        customer: {},        
        cities: [],
      }
    },

    props: ["cnpj"],

    components: { TheMask },

    beforeDestroy() {
      $(".create-customer-modal").remove()
    },
    
    mounted() {

      this.initData()

      $(".form-dropdown").dropdown()
    },

    methods: {

      initData() {

        this.loading = false
        this.creating = false   
        this.cities = [{ id: "*", name: "Selecione o estado..." }]
        this.customer = {
          code: "",
          unit: "",
          name: "",
          state: "*",
          cityCode: "*",
          cnpj: "",
          ddd: "",
          phone: "",
          email: "",
          isProspect: true,
        }

      },

      async onChangeState() {

        if (!this.customer.state || this.customer.state == "*")
          return

        this.loading = true

        try {

          const cities = await CustomerService.getCities(this.customer.state)
                    
          this.cities = []
          this.cities.push({ id: "*", name: "Selecione..." })
          
          cities.forEach((city) => this.cities.push(city))

          this.customer.cityCode = "*"
          
          this.loading = false
          
        } catch (error) {
          
          this.loading = false
          this.$errorHandler(error)
        }
      },

      onConfirm() {

        if (this.validData())
          this.createCustomer()
      },

      validData() {

        if (this.creating)
          return false

        let isOk = true
        let message = ""

        if (!this.customer.name) {
          message = "Informe a razão social"
        } else if (!this.customer.state || this.customer.state == "*") {
          message = "Informe o estado"
        } else if (!this.customer.cityCode || this.customer.cityCode == "*") {
          message = "Informe a cidade"
        } else if (!this.customer.ddd) {
          message = "Informe o DDD"
        } else if (!this.customer.phone) {
          message = "Informe o telefone"      
        } else if (!this.customer.email) {
          message = "Informe o e-mail"  
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },

      async createCustomer() {

        this.creating = true

        try {

          this.customer.cnpj = this.cnpj

          const response = await CustomerService.create(this.customer)
           
          this.customer.code = response.code
          this.customer.unit = response.unit        

          $("#create-customer-dialog").modal("hide")                                        

          this.$emit("onCreate", this.$cloneObject(this.customer))

          this.initData()

          //$("#select-state").dropdown("set selected", "*")
          //$("#select-ctity").dropdown("set selected", "*")
          
        } catch (error) {
          
          this.creating = false
          this.$errorHandler(error)
        }
      },
      
     },
  }

</script>

